import React from 'react';
import PropTypes from 'prop-types';
import OPE from 'components/common/EpiOnPageEdit';
import { HtmlComponent, HtmlComponentContainer } from 'features/HtmlComponent';
import { Date } from 'features/Date';
import { Paragraph, Title } from 'components/text';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { colors as Colors } from 'constants/colors';
import { UnderlineContainer, UnderlineContainerText } from 'components/UnderlineContainer';
import { FlexContainerCentered } from 'components/flex';
import { PageContent } from '../components';
import Breadcrumbs from 'components/breadcrumbs';

class RemissPage extends React.Component {
  render() {
    if (!this.props) return null;
    const {
      type,
      mainBody,
      header,
      date,
      mainIntro,
      locationAndDate,
      receiver,
      answer,
      breadcrumbs
    } = this.props;
    const htmlComponentStyles = {
      margin: '0 auto',
      maxwidth: '35rem'
    };
    return (
      <div className="RemissPage">
        <FlexContainerCentered alignItems="center">
          <PageContent>
            {breadcrumbs && <Breadcrumbs breadcrumbs={breadcrumbs} margin="1em auto 0 0" />}
            <UnderlineContainer
              hide={!type}
              position="bottom"
              color={type ? Colors.ORANGE : Colors.TRANSPARENT}>
              <OPE propertyName="type">
                <UnderlineContainerText>{type}</UnderlineContainerText>
              </OPE>
            </UnderlineContainer>
            <OPE propertyName="header">
              <Title black>{header}</Title>
            </OPE>
            {mainIntro && (
              <OPE propertyName="mainIntro" floating={false}>
                <Paragraph>{mainIntro}</Paragraph>
              </OPE>
            )}

            <HtmlComponentContainer margin={'0 auto'} maxwidth={'35rem'}>
              {date && <Date date={date} />}
              <OPE propertyName="receiver" floating={true}>
                <Paragraph lineheight="1.36em" fontSize=" 0.9167rem" width="100%" nomargin>
                  {receiver}
                </Paragraph>
              </OPE>
              <OPE propertyName="locationAndDate" floating={true}>
                <Paragraph lineheight="1.36em" fontSize="0.9167rem">
                  {locationAndDate}
                </Paragraph>
              </OPE>
              <OPE propertyName="mainBody" floating={false}>
                <HtmlComponent style={htmlComponentStyles} html={mainBody} />
              </OPE>
              <OPE propertyName="answer" floating={false}>
                <HtmlComponent style={htmlComponentStyles} html={answer} />
              </OPE>
            </HtmlComponentContainer>
          </PageContent>
        </FlexContainerCentered>
      </div>
    );
  }
}

const mapStateToProps = state => ({ currentPage: state.page });

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RemissPage);

RemissPage.propTypes = {
  type: PropTypes.string,
  mainBody: PropTypes.string,
  header: PropTypes.string,
  date: PropTypes.string,
  mainIntro: PropTypes.string,
  locationAndDate: PropTypes.string,
  receiver: PropTypes.string
};
